// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box[data-v-01938d6f]{margin:0 0 .75rem;text-transform:capitalize}a[data-v-01938d6f]{color:inherit}a[data-v-01938d6f],a[data-v-01938d6f]:focus,a[data-v-01938d6f]:hover{-webkit-text-decoration:none;text-decoration:none}small[data-v-01938d6f]{color:#767676}.profile-wrapper[data-v-01938d6f]{margin-right:.75rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
